import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { AddressTypes } from "_helpers";
import { addressService } from "_services";
import TabMenu from "../TabMenu";
import { Auth } from "_helpers";

function Summary({ history, match }) {
  const { id, addressId } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState({});
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    addressService
      .getById(id, addressId)
      .then((x) => {
        setIsLoading(false);
        setAddress(x.content);
        onFill(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, []);

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        addressService
          .update(id, addressId, values)
          .then(() => {
            message.success("Successfully updated!");
            setIsLoading(false);
            history.push(
              `${path}`.replace(":id", id).replace(":addressId", addressId)
            );
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push(".");
  };

  const getAdditionalButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isLoading}>
            Save
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">
              <span>Dashboard</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/companies">
              <span>Company Search</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/companies/${id}/summary`}>
                Company: {address?.company?.code}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/companies/${id}/addresses`}>Addresses</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/companies/${id}/addresses/${addressId}`}>
                Addresses: {address.code}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getAdditionalButtons()}
      >
        <Page inner>
          <TabMenu menu="addresses" id={id} />
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input placeholder="Code" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[{ required: true, message: "Address is required" }]}
                >
                  <Input placeholder="Address" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="area" label="Area">
                  <Input placeholder="Area" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="city"
                  label="City"
                  rules={[{ required: true, message: "City is required" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="addressType"
                  label="Type"
                  rules={[
                    { required: true, message: "Address type is required" },
                  ]}
                >
                  <Select placeholder="Please select">
                    {AddressTypes.map((t) => (
                      <Option value={t.value} key={t.value}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}></Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
